const DEV_MODE = false;
export const API_BASE = DEV_MODE === true ? 'http://localhost:3223' : 'https://vicaro-api.onrender.com';
export const API_URL = DEV_MODE === true ? 'http://localhost:3223' : 'https://vicaro-api.onrender.com';
export const S3_BUCKET = "https://myvicaro.s3.eu-central-1.amazonaws.com/"
export const S3_BUCKET_RESIZE = "https://myvicaro-resized.s3.eu-central-1.amazonaws.com/"
